class emissionSourceControll {
    constructor() {
        this.areas = {};
        this.areasNames = {};
        this.emissionList = {};
        this.originEmissionList = {};
        this.relations = {};
        this.areaEmissions = {};
        this.areaEmissions_ = {};
        this.allemissions = {};

    }
    // 获取所有区域的经纬度
    setAreas(datas) {
        this.areas = {};
        let index = 0
        if (Array.isArray(datas)) {
            datas.forEach(item => {
                if (!this.areas[item.name]) {
                    this.areas[item.name] = {
                        id: item.id,
                        positions: []
                    }
                    this.areasNames[item.id] = {
                        index: index,
                        name: item.name,
                    }
                    index++;
                    this.areas[item.name]['positions'][0] = {
                        lat: item.latitude,
                        lon: item.longitude,
                    }
                } else {
                    this.areas[item.name]['positions'].push({
                        lat: item.latitude,
                        lon: item.longitude
                    })
                }
            })
        }
    }

    getAreas() {
        let arr = [];
        for (let key in this.areas) {
            let areaInfo = this.areas[key]
            let areaName = key;
            areaInfo['name'] = areaName;
            areaInfo["baseColor"] = "#00FF4D";
            areaInfo["highlightColor"] = "#FF0004";
            areaInfo["visible"] = true;
            arr.push(areaInfo);
        }
        return arr
    }
    getAreaInfoById(id) {
        let area = this.areasNames[id]
        let areaName = area.name;
        let areaInfo = this.getAreaByName(areaName);
        areaInfo['name'] = areaName;
        areaInfo["baseColor"] = "#00FF4D";
        areaInfo["highlightColor"] = "#FF0004";
        areaInfo["visible"] = true;
        let arr = []
        arr[0] = areaInfo;
        return arr;
    }
    getAreaInfoById_(id) {
        let area = this.areasNames[id]
        if (area) {
            let areaName = area.name;
            let areaInfo = this.getAreaByName(areaName);
            areaInfo['name'] = areaName;
            areaInfo["baseColor"] = "#00EB64";
            areaInfo["highlightColor"] = "#00EB64";
            areaInfo["visible"] = true;
            return areaInfo;
        } else {
            return false;
        }
    }
    getAreaByName(name) {
        if (this.areas[name]) {
            return this.areas[name]
        } else {
            debugger
        }
    }
    getAreaNames() {
        return this.areasNames
    }

    setEmissionList(data) {
        if (!Array.isArray(data)) return;
        data.forEach((item, index) => {
            this.emissionList[item.id] = {
                "id": item.id,
                "customerId": 38,
                "color": "#00EB64",
                "processNameprocessName": item.processes,
                "name": item.emissionSourceName,
                "emissionType": item.emissionSourceType,
                "parentProcessId": 0,
                "level": 2,
                "mapId": item.dictId.toString(),
                "longitude": item.longitude * 1,
                "latitude": item.latitude * 1,
                "sortId": index,
                "device": null,
                "downstreamEmissionInfo": null
            }
            item.areaName = this.areasNames[item.dictId].name;
            this.originEmissionList[item.id] = item
            this.originEmissionList[item.id]['emName'] = item.emissionSourceName;
        })
        this.setAreaEmission();
    }

    setAreaEmission() {
        for (let key in this.emissionList) {
            let item = this.emissionList[key]
            if (!this.areaEmissions[item.mapId]) {
                this.areaEmissions[item.mapId] = {
                    areaName: this.areasNames[item.mapId] ? this.areasNames[item.mapId].name : "null",
                    emmissionList: []
                }
                this.areaEmissions[item.mapId]['emmissionList'].push(item);
            } else {
                let currentAreaEmissions = this.areaEmissions[item.mapId]['emmissionList'];
                if (currentAreaEmissions.findIndex((emiss) => { return item.id == emiss.id }) < 0) {
                    this.areaEmissions[item.mapId]['emmissionList'].push(item);
                }
            }
        }
        for(let key in this.originEmissionList) {
            let item = this.originEmissionList[key]
            if (!this.areaEmissions_[item.dictId]) {
                this.areaEmissions_[item.dictId] = {
                    areaName: this.areasNames[item.dictId] ? this.areasNames[item.dictId].name : "null",
                    emmissionList: []
                }
                this.areaEmissions_[item.dictId]['emmissionList'].push(item);
            } else {
                let currentAreaEmissions = this.areaEmissions_[item.dictId]['emmissionList'];
                if (currentAreaEmissions.findIndex((emiss) => { return item.id == emiss.id }) < 0) {
                    this.areaEmissions_[item.dictId]['emmissionList'].push(item);
                }
            }
        }
    }
    getEmissionsByAreaId(areaId) {
        if (this.areaEmissions[areaId]) {
            return this.areaEmissions[areaId]['emmissionList']
        } else {
            return false
        }
    }
    getOriginEmissionListByAreaId(areaId){
        if (this.areaEmissions_[areaId]) {
            return this.areaEmissions_[areaId]['emmissionList']
        } else {
            return false
        }
    }
    getAreaLine(areaId1, areaId2) {
        var AreaLineData = {
            data:
            {
                "StartId": areaId1,
                "EndId": areaId2,
                "color": "#00EB64",
                "height": 200,
                "width": 10
            },
        };
        return AreaLineData
    }

    // 根据设备编码，管理区域上下游关系
    setAreasByDeviceNo_(areaIds, deviceNo, tap) {
        this.relations = {
            "deviceNo": {
                pre: [],
                current: [],
                next: [],
            }
        }
        this.relations[deviceNo][tap] = areaIds
    }
    setAreasByDeviceNo(areaIds, deviceNo) {
        this.relations[deviceNo] = areaIds
    }
    // 根据设备编码获取上游、下游区域和当前设备的关联区域 
    getRelationAreas(deviceNo, tap) {
        let deviceNoArr = []
        for (let key in this.relations) {
            if (key.split("|")[0] == deviceNo) {
                deviceNoArr.push(key)
            }
        }
        let areas = []
        deviceNoArr.forEach(el => {
            if (this.relations[el]) {
                this.relations[el][tap].forEach(areaId => {
                    let areaInfo = this.getAreaInfoById_(areaId)
                   if(areaInfo) {
                    areas.push(areaInfo)
                   }
                })
            }
        })
        if (areas.length > 0) {
            return areas;
        } else {
            return false
        }
    }
    //根据设备编码，区域Id,获取区域上下游关系 
    getAreaRelationsByAreaId(deviceNo, tap) {
        let relationLines = []
        let deviceNoArr = []
        for (let key in this.relations) {
            if (key.split("|")[0] == deviceNo) {
                deviceNoArr.push(key)
            }
        }
        deviceNoArr.forEach(deviceNo_ => {
            if (this.relations[deviceNo_]) {
                this.relations[deviceNo_][tap].forEach((areaId, index) => {
                    let areaId1 = areaId;
                    let areaId2 = deviceNo_.split("|")[1];
                    if (tap == 'pre') {
                        let relationLine = this.getAreaLine(areaId1 * 1, areaId2 * 1);
                        relationLines.push(relationLine)
                    } else {
                        let relationLine = this.getAreaLine(areaId2 * 1, areaId1 * 1);
                        relationLines.push(relationLine)
                    }
                })
            }
        })
        
        if (relationLines.length == 0) {
            return false
        } else {
            return relationLines;
        }
    }
    // 根据设备Id获取排放源点位
    getEmissionListByDeviceNo(deviceNo,tap = "current"){
        let deviceNoArr = []
        let emissionList = []
        for (let key in this.relations) {
            if (key.split("|")[0] == deviceNo) {
                deviceNoArr.push(key)
            }
        }
        deviceNoArr.forEach(deviceNo_ => {
            if (this.relations[deviceNo_]) {
                this.relations[deviceNo_][tap].forEach((areaId) => {
                   let arr = this.getOriginEmissionListByAreaId(areaId);
                   if(arr) {
                    emissionList = emissionList.concat(arr)
                   }
                })
            }
        })
        return emissionList
    }

}
emissionSourceControll.instence = new emissionSourceControll();
export default emissionSourceControll.instence;